export const STAGE_NODE_DEFAULT_WIDTH = 340;
export const STAGE_NODE_DEFAULT_HEIGHT = 128;
export const STAGE_NODE_MIN_WIDTH = 220;
export const STAGE_NODE_MIN_HEIGHT = 96;
export const STAGE_NODE_MAX_WIDTH = 800;
export const STAGE_NODE_MAX_HEIGHT = 420;

export const SOURCE_NODE_DEFAULT_WIDTH = 160;
export const SOURCE_NODE_DEFAULT_HEIGHT = 78;
export const SOURCE_NODE_MIN_WIDTH = 150;
export const SOURCE_NODE_MIN_HEIGHT = 68;
export const SOURCE_NODE_MAX_WIDTH = 640;
export const SOURCE_NODE_MAX_HEIGHT = 300;

export const NODE_COLOR_SWATCHES = [
  "#2563eb",
  "#0ea5e9",
  "#14b8a6",
  "#22c55e",
  "#f59e0b",
  "#ef4444",
  "#8b5cf6",
  "#64748b",
] as const;

const HEX_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;

export function normalizeNodeColor(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  const trimmed = value.trim();
  if (!trimmed) return undefined;
  return HEX_COLOR_PATTERN.test(trimmed) ? trimmed.toLowerCase() : undefined;
}

export function isValidNodeColor(value: unknown): value is string {
  return normalizeNodeColor(value) !== undefined;
}

export function clampNodeDimension(
  value: unknown,
  min: number,
  max: number,
  fallback: number,
): number {
  const numeric = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(numeric)) return fallback;
  return Math.min(max, Math.max(min, Math.round(numeric)));
}
